import type { MomentInput } from 'moment';
import type { FunctionComponent, ReactElement } from 'react';

import useFromNow, { ONE_MINUTE } from './useFromNow';

export type FromNowProps = {
  date: MomentInput;
  updateInterval?: number;
};

/**
 * Component which uses the useFromNow hook to ensure
 * the date you pass to it is always kept up-to-date.
 * Mostly a convenience component when you don't want
 * to use the hook directly.
 *
 * @param {FromNowProps} props - FromNow props
 * @param {MomentInput} props.date - Could be a string or any valid moment input.
 * @param {number} [props.updateInterval] - If you wanted to customize how often this is updated.
 * @example
 * const MyComponent = ({ updatedAt }) => (
 *   <div>
 *     Updated <FromNow date={updatedAt} />
 *   </div>
 * );
 */
const FromNow: FunctionComponent<FromNowProps> = ({ date, updateInterval = ONE_MINUTE }) =>
  useFromNow(date, updateInterval) as unknown as ReactElement;

export default FromNow;
